<template>
  <div>
    <v-client-table
      id="audit-change-log-table"
      :columns="columns"
      :data="rows"
      :options="options"
      :theme="theme"
      class="w-100"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import moment from 'moment'

Vue.use(ClientTable)

export default {
  name: 'AuditChangeLogTable',
  components: {
    ClientTable
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      columns: [
        'action',
        'user',
        'date'
      ],
      options: {
        filterable: []
      },
      theme: 'bootstrap4',
    }
  },
  computed: {
    rows () {
      return this.model && Object.keys(this.model.attributes).map(key => {
        if (key.includes('_at') && this.model[key]) {
          let action = key.split('_')[0]
          let user = this.model[`audit_${action}_by`] ? (this.model[`audit_${action}_by`].name || this.model[`audit_${action}_by`].email) : '-'
          let date = this.model[key] ? moment(this.model[key]).format("YYYY-MM-DD HH:mm:ss") : '-'

          return {
            action: this.lodash.startCase(action),
            user,
            date
          }
        }
      }).filter(Boolean) || []
    }
  }
}
</script>
